import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * 会員登録用Dto
 */
@JsonObject('RegisterUserInfo')
export default class RegisterUserInfo {
  constructor() {
    this.userId = undefined;
    this.password = undefined;
    this.passwordConfirm = undefined;
    this.firstName = null;
    this.lastName = null;
    this.firstNameKana = null;
    this.lastNameKana = null;
    this.gender = null;
    this.birthYear = undefined;
    this.birthMonth = undefined;
    this.birthDate = undefined;
    this.postalCode = null;
    this.prefecture = null;
    this.city = null;
    this.street = null;
    this.buildingName = null;
    this.phoneNumber01 = null;
    this.phoneNumber02 = null;
    this.phoneNumber03 = null;
    this.isReceiveMailAnnounce = true;
    this.token = undefined;
    this.isValidationOnly = false;
    this.examRankCode = undefined;
    this.mailAddress = undefined;
  }

  @JsonProperty('user_id')
  public userId?: string;

  @JsonProperty('password')
  public password?: string;

  @JsonProperty('password_confirmation')
  public passwordConfirm?: string;

  @JsonProperty('first_name')
  public firstName?: string|null;

  @JsonProperty('last_name')
  public lastName?: string|null;

  @JsonProperty('first_name_kana')
  public firstNameKana?: string|null;

  @JsonProperty('last_name_kana')
  public lastNameKana?: string|null;

  @JsonProperty('gender')
  public gender?: string|null;

  @JsonProperty('birth_year')
  public birthYear?: string;

  @JsonProperty('birth_month')
  public birthMonth?: string;

  @JsonProperty('birth_date')
  public birthDate?: string;

  @JsonProperty('postal_code')
  public postalCode?: string|null;

  @JsonProperty('prefecture')
  public prefecture?: string|null;

  @JsonProperty('city')
  public city?: string|null;

  @JsonProperty('street')
  public street?: string|null;

  @JsonProperty('building_name')
  public buildingName?: string|null;

  @JsonProperty('phone_number01')
  public phoneNumber01?: string|null;

  @JsonProperty('phone_number02')
  public phoneNumber02?: string|null;

  @JsonProperty('phone_number03')
  public phoneNumber03?: string|null;

  @JsonProperty('examinee_attributes')
  public examineeAttributes: object[] = [];

  @JsonProperty('is_receive_mail_announce')
  public isReceiveMailAnnounce: boolean;

  @JsonProperty('token')
  public token?: string;

  @JsonProperty('is_validation_only')
  public isValidationOnly: boolean;

  // 内部パラメータ
  public examRankCode?: string;

  public mailAddress?: string;
}
